import styled from 'styled-components';
import { colors, spacing, typography, borderRadius, shadows } from '../../styles/theme';

// Shared by EventDetailsPage and any section rendered alongside it.
export const DetailSection = styled.section`
  background: ${colors.white};
  border: 1px solid ${colors.border.light};
  border-radius: ${borderRadius.xl};
  padding: ${spacing[6]};
  margin-bottom: ${spacing[6]};
  box-shadow: ${shadows.sm};
`;

export const DetailSectionTitle = styled.h2`
  font-size: ${typography.fontSizes.xl};
  font-weight: ${typography.fontWeights.semibold};
  color: ${colors.text.primary};
  margin-bottom: ${spacing[4]};
`;
